export const getPriorityTextClass = (priority) => {
  const normalized = `${priority || ''}`.trim().toLowerCase();

  switch (normalized) {
    case 'critical':
      return 'text-rose-400 font-semibold';
    case 'high':
      return 'text-orange-400 font-medium';
    case 'medium':
      return 'text-amber-400 font-medium';
    case 'low':
      return 'text-emerald-400 font-medium';
    default:
      return 'text-gray-400';
  }
};

export const formatPriorityLabel = (priority) => {
  if (!priority) return 'N/A';
  const normalized = `${priority}`.trim().toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};
